"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _ = require("./..");

var _propTypes = _interopRequireDefault(require("prop-types"));

var CheckboxInput = function CheckboxInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["value", "onChange"]);
  return /*#__PURE__*/_react.default.createElement(_.Input, (0, _extends2.default)({}, moreProps, {
    type: "checkbox",
    checked: !!value,
    onChange: function onChange(event) {
      return _onChange(event.target.checked, event);
    }
  }));
};

CheckboxInput.propTypes = {
  name: _propTypes.default.string,
  value: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
CheckboxInput.defaultProps = {};
CheckboxInput.displayName = 'CheckboxInput';
var _default = CheckboxInput;
exports.default = _default;